import { gql } from '@apollo/client'

import blogListFragment from 'js/blog/fragments/listFragment'
import discussionListFragment from 'js/discussions/fragments/listFragment'
import eventListFragment from 'js/events/fragments/listFragment'
import { genericArticleListFragment } from 'js/genericArticle/fragments/genericArticleEntity'
import statusUpdateListFragment from 'js/group/StatusUpdate/fragments/listFragment.js'
import { listFragment as magazineIssueListFragment } from 'js/magazine-issue/lib/fragments'
import newsListFragment from 'js/news/fragments/listFragment'
import pageListFragment from 'js/page/listFragment'
import {
    episodeListFragment,
    podcastListFragment,
} from 'js/podcast/fragments/list'
import questionListFragment from 'js/questions/fragments/listFragment'
import wikiListFragment from 'js/wiki/fragments/listFragment'

export default gql`
query ActivityList(
    $containerGuid: String
    $groupGuid: String
    $offset: Int!
    $limit: Int!
    $subtypes: [String!]
    $groupFilter: [String!]
    $tagCategories: [TagCategoryInput!]
    $orderBy: OrderBy
    $orderDirection: OrderDirection
    $sortPinned: Boolean
    $statusPublished: [StatusPublished]
    $userGuid: String
    $eventFilter: EventFilter
) {
    activities(
        offset: $offset
        limit: $limit
        containerGuid: $containerGuid
        tagCategories: $tagCategories
        subtypes: $subtypes
        groupFilter: $groupFilter
        orderBy: $orderBy
        orderDirection: $orderDirection
        sortPinned: $sortPinned
        statusPublished: $statusPublished
        userGuid: $userGuid
        eventFilter: $eventFilter
    ) {
        total
        edges {
            guid
            type
            entity {
                guid
                ...StatusUpdateListFragment
                ...BlogListFragment
                ...DiscussionListFragment
                ...EventListFragment
                ...NewsListFragment
                ...QuestionListFragment
                ...WikiListFragment
                ...PageListFragment
                ${podcastListFragment}
                ${episodeListFragment}
                ${magazineIssueListFragment}
                ${genericArticleListFragment}
            }
        }
    }
}
${statusUpdateListFragment}
${blogListFragment}
${discussionListFragment}
${eventListFragment}
${newsListFragment}
${questionListFragment}
${wikiListFragment}
${pageListFragment}
`
